export enum AnalyticsDevice {
	Desktop = 'desktop',
	Mobile = 'mobile'
}

export enum AnalyticsDestination {
	AgentCreator = 'agent_creator',
	Dashboard = 'dashboard',
	Root = 'root'
}

export enum AnalyticsEvent {
	AccessDeniedShown = 'access_denied_shown',
	ApiRequestCompleted = 'api_request_completed',
	ApiRequestFailed = 'api_request_failed',
	ApiRequestStarted = 'api_request_started',
	ButtonClicked = 'button_clicked',
	CreatorEntryFailed = 'creator_entry_failed',
	CreatorOpened = 'creator_opened',
	CreatorRedirectStarted = 'creator_redirect_started',
	FeatureFlagEvaluated = 'feature_flag_evaluated',
	FieldBlurred = 'field_blurred',
	FieldChanged = 'field_changed',
	FieldCleared = 'field_cleared',
	FieldFocused = 'field_focused',
	FieldValidationChanged = 'field_validation_changed',
	JourneyAbandoned = 'journey_abandoned',
	JourneyCompleted = 'journey_completed',
	JourneyStarted = 'journey_started',
	LinkClicked = 'link_clicked',
	ModalClosed = 'modal_closed',
	ModalOpened = 'modal_opened',
	OptionSelected = 'option_selected',
	PortalRedirectClicked = 'portal_redirect_clicked',
	PortalRedirectStarted = 'portal_redirect_started',
	RealtimeConnected = 'realtime_connected',
	RealtimeDisconnected = 'realtime_disconnected',
	RealtimeEventReceived = 'realtime_event_received',
	StepClosed = 'step_closed',
	StepCompleted = 'step_completed',
	StepLeft = 'step_left',
	StepOpened = 'step_opened',
	StepRevisited = 'step_revisited',
	StepViewed = 'step_viewed',
	SubmitBlockedByValidation = 'submit_blocked_by_validation',
	TokenExchangeCompleted = 'token_exchange_completed',
	TokenExchangeFailed = 'token_exchange_failed',
	TokenExchangeStarted = 'token_exchange_started',
	ValidationErrorResolved = 'validation_error_resolved',
	ValidationErrorShown = 'validation_error_shown'
}

export enum AnalyticsEventType {
	Api = 'api',
	Field = 'field',
	Flow = 'flow',
	Interaction = 'interaction',
	Navigation = 'navigation',
	Step = 'step',
	System = 'system',
	Validation = 'validation'
}

export enum AnalyticsFailureReason {
	InsufficientDescription = 'insufficient_description',
	InvalidSource = 'invalid_source',
	MissingActorId = 'missing_actor_id',
	MissingCode = 'missing_code',
	MissingCustomer = 'missing_customer',
	MissingExternalCustomerId = 'missing_external_customer_id',
	ReinitializeFailed = 'reinitialize_failed',
	SaveFailed = 'save_failed',
	SourceUnusable = 'source_unusable',
	TokenExchangeFailed = 'token_exchange_failed',
	TrainingInProgress = 'training_in_progress',
	UnexpectedError = 'unexpected_error',
	WebsiteUnavailable = 'website_unavailable'
}

export enum AnalyticsJourney {
	AgentConfiguration = 'agent_configuration',
	CreatorSetup = 'creator_setup'
}

export enum AnalyticsResult {
	Abandoned = 'abandoned',
	Blocked = 'blocked',
	Completed = 'completed',
	Failed = 'failed',
	Started = 'started'
}

export enum AnalyticsScreen {
	AccessDenied = 'access_denied'
}

export enum AnalyticsStage {
	AgentActivation = 'agent_activation',
	ConfigChecklist = 'config_checklist',
	CreatorEntry = 'creator_entry',
	CreatorOnboarding = 'creator_onboarding',
	PortalRedirect = 'portal_redirect',
	Provisioning = 'provisioning',
	SafeActivation = 'safe_activation',
	TrainingReinitialize = 'training_reinitialize'
}
